import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const ProjectSelect = ({ value, onChange, testid = "project-select", disabled }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/projects").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  return (
    <select className="w-full rounded-md border bg-background px-3 py-2 text-sm" value={value || ""} onChange={(e) => onChange(e.target.value)} disabled={disabled} data-testid={testid}>
      <option value="">No project</option>
      {items.map((p) => <option key={p.id} value={p.id}>{p.ref} · {p.name}</option>)}
    </select>
  );
};
